import { DEFAULT_ACTIVE_CATEGORIES } from '../constants';
import { getActiveCategories } from './getActiveCategories';

/**
 * The function checks the active categories array length.
 * The "Strictly-necessary" (C0001) category is always enabled. If a user declines all cookies,
 * the array remains unchanged and has a length equal to one.
 * However, if a user accepts additional categories, they will be added to the array.
 */
export const runForRequiredCategories = (callback: () => void) => {
  if (getActiveCategories().length === DEFAULT_ACTIVE_CATEGORIES.length) {
    callback();
  }
};
